import React, { useState } from 'react'; // Importa useState aquí
import Sidebar from '../components/Sidebar'; 
import { useNavigate } from 'react-router-dom';
import logoamerisa from '../assets/logoamerisa.png';

const AccessDenied = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeItem, setActiveItem] = useState('Seguridad');
    const navigate = useNavigate();

    const handleLogout = () => {
        console.log('Logout clicked!');
        localStorage.clear();
        setTimeout(() => {
          navigate('/login');
        }, 0);
       
    };

    return (
        <div className="flex">
            {/* Sidebar */}
            <Sidebar
                isOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                onLogout={handleLogout}
            />

            {/* Contenido principal */}
            <div
                className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen p-6`}
            >
                {/* Barra superior con logo y barra de búsqueda */}
                <div className="bg-sky-900 text-white p-4 flex items-center justify-between">
                    <img src={logoamerisa} alt="Logo" className="h-8" />
                    <div className="relative max-w-sm w-full">
                        <input
                            type="text"
                            placeholder="Buscar..."
                            className="w-full p-2 pl-10 bg-white border rounded-md text-sm text-gray-700"
                        />
                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                            🔍
                        </span>
                    </div>
                    
                </div>
                <div className="flex flex-col items-center justify-center h-auto ">
                    <h1 className="text-4xl font-bold text-red-600 mb-4 mt-20">
                        Acceso Denegado
                    </h1>
                    <p className="text-xl text-gray-700 text-center max-w-2xl">
                        No cuentas con los permisos necesarios para acceder a esta sección.
                        Por favor, contacta al administrador del sistema para obtener acceso.
                    </p>
                    </div>
            </div>
        </div>
    );
};

export default AccessDenied;